import React from 'react';
import { BodyMBold } from 'components/Typography/Typography';
import CustomRadio from 'components/CustomRadio/CustomRadio';
import styles from 'assets/jss/material-dashboard-pro-react/views/topUpAddOns/donationTabStyle';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CharityLogo from './CharityLogo';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISingleCharityProps {
	isChecked: boolean;
	check: () => void;
	name: string;
	logo: string;
	background: string;
}

const Charity = ({ isChecked, check, name, logo, background }: ISingleCharityProps) => {
	const classes = useStyles();

	const checkedStyle = isChecked
		? { boxShadow: `0 4px 4px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px ${background}` }
		: {};

	return (
		<div className={classes.singleCharityWrapper}>
			<CustomRadio checked={isChecked} onChange={check} />
			<div style={{ backgroundColor: background, ...checkedStyle }}>
				<CharityLogo url={logo} />
				<div className={classes.charityName}>
					<BodyMBold color="primary-dark" disableMargin>
						{name}
					</BodyMBold>
				</div>
			</div>
		</div>
	);
};

export default Charity;
